import { create } from 'zustand'

interface RaundStore {
  newRewardsCount: number
  setNewRewardsCount: (v: number) => void
}

export const useRaundStore = create<RaundStore>((set) => ({
  newRewardsCount: 0,
  setNewRewardsCount: (v) => set({ newRewardsCount: v }),
}))
